import { z } from "zod";
// A programme mirrored from ICIS (csg_program), as the admin screens pick from:
// its id, display name, and whether ICIS still had it active at the last import.
// Reference data shared across screens — the rollout, the question editor, the
// session-template builder — so it lives on its own rather than belonging to
// whichever screen asked first. `active` travels with the name because every
// screen has to decide whether a retired programme is still pickable, and that
// answer differs per screen.
export const ProgramSummarySchema = z.object({
    id: z.guid(),
    name: z.string(),
    active: z.boolean(),
});
export const ProgramsResponseSchema = z.object({
    programs: ProgramSummarySchema.array(),
});
